import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateComponentTransparent } from '../../redux/component_transparent/component_actions';

const mapStateToProps = state => ({
  isDuplicating: state.component.transparent.isDuplicating,
  errorMessage: state.component.transparent.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateComponentTransparent(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/TransparentComponentDuplicateModal.js